import { Button, Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing, MonoText, MoneyDisplay } from "components";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell>Code</TableCell>
            <TableCell>Price</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map(model => (
            <TableRow hover key={model.id}>
              <TableCell>
                <Link color="inherit" component={RouterLink} to={`/class-passes/${model.id}/summary`} variant="h6">
                  {model.name_en}
                </Link>
                <div>
                  <Typography variant="caption"><MonoText>{model.reference}</MonoText></Typography>
                </div>
              </TableCell>
              <TableCell>
                <MonoText>{model.sku}</MonoText>
              </TableCell>
              <TableCell>
                <MonoText>{model.code}</MonoText>
              </TableCell>
              <TableCell>
                <MonoText><MoneyDisplay amount={model.price} currency={model.price_currency} /></MonoText>
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/class-passes/${model.id}/summary`} variant="outlined">
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;